import { makeStyles, Typography, TypographyProps } from '@material-ui/core'
import TagIcon from '@material-ui/icons/LocalOffer'
import classnames from 'classnames'
import React from 'react'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.primary.dark,
    color: theme.palette.primary.contrastText,
    padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
    borderRadius: theme.spacing(2),
    display: 'inline-block',
    fontFamily: theme.typography.h1.fontFamily,
    marginRight: theme.spacing(1),
  },
}))

const Pill: React.FC<TypographyProps> = ({
  children,
  className,
  ...componentProps
}) => {
  const classes = useStyles()
  return (
    <Typography
      component="span"
      className={classnames(classes.root, className)}
      align="center"
      variant="body2"
      {...componentProps}
    >
      <TagIcon /> {children}
    </Typography>
  )
}

export default Pill
